import React from 'react';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { ModalLayout } from '../../../modal';
import { StyledConfirmText } from './room-code-confirm-modal.styles';
import { RoomCodeConfirmModalProps } from './room-code-confirm-modal.types';
export const RoomCodeConfirmModal = ({
  handleEnableRoomCodeInput,
  isDisabled = false
}: RoomCodeConfirmModalProps) => {
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const handleRoomInput = () => {
    handleEnableRoomCodeInput();
    setOpenModal(false);
  };
  return <ModalLayout open={openModal} openChange={value => setOpenModal(value)} triggerButtonColor="add" triggerText="Edit" triggerButtonIcon={faPenToSquare} modalTitleText="Edit room code" closeButtonText="Cancel" actionButtonText="Edit room code" handleActionButton={handleRoomInput} isTriggerButtonDisabled={isDisabled} warnBoxText={`The room code determines the room's url, so updating it will invalidate the current URL. If you have shared room links with people, you will have to update them.  `} data-sentry-element="ModalLayout" data-sentry-component="RoomCodeConfirmModal" data-sentry-source-file="room-code-confirm-modal.tsx">
      <StyledConfirmText data-sentry-element="StyledConfirmText" data-sentry-source-file="room-code-confirm-modal.tsx">Are you sure you want to modify the room code? </StyledConfirmText>
    </ModalLayout>;
};